import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('reports.data.ReportConfig', {
    trackingColumnTitleText: '{fieldName} used in line items (at least one line item should match)',
});
